import { Link } from "wouter";
import { useCompare } from "@/lib/compare-context";
import { Button } from "@/components/ui/button";
import { ArrowsUpFromLine, X } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { useTheme } from "@/lib/theme-context";

export function CompareBar() {
  const { compareIds, compareCount, clearCompare } = useCompare();
  const { t } = useI18n();
  const theme = useTheme();

  if (theme?.compareEnabled === "false") return null;
  if (compareCount === 0) return null;

  return (
    <div className="fixed bottom-0 start-0 end-0 z-50 bg-background border-t shadow-lg">
      <div className="container flex items-center justify-between py-3">
        <div className="flex items-center gap-3">
          <ArrowsUpFromLine className="h-5 w-5 text-primary" />
          <span className="font-medium">
            {compareCount} {compareCount > 1 ? t.compare.productsSelected : t.compare.productSelected} {t.compare.selectedForComparison}
          </span>
        </div>
        <div className="flex items-center gap-2">
          <Button variant="outline" size="sm" onClick={clearCompare}>
            <X className="me-1 h-4 w-4" /> {t.compare.clear}
          </Button>
          <Button size="sm" asChild disabled={compareCount < 2}>
            <Link href="/compare">
              {t.compare.compareNow}
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
